import { render, staticRenderFns } from "./SearchHorseBlock.vue?vue&type=template&id=57776bbe&scoped=true&"
import script from "./SearchHorseBlock.vue?vue&type=script&lang=ts&"
export * from "./SearchHorseBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57776bbe",
  null
  
)

export default component.exports